(() => {
    const requestedScripts = new Set();
    const loadedScripts = new Set();

    const preloadScript = (url) => {
        const link = document.createElement('link');

        link.rel = 'preload';
        link.as = 'script';
        link.href = url;

        document.head.appendChild(link);
    }

    const loadScript = (url, callback) => {
        if (requestedScripts.has(url)) {
            const check = () => {
                if (!loadedScripts.has(url)) {
                    window.setTimeout(check, 100);
                    return;
                }

                callback();
            };

            check();
            return;
        }

        requestedScripts.add(url);

        const script = document.createElement('script');

        if (callback) {
            script.onload = () => {
                loadedScripts.add(url);
                callback();
            };
        }
        script.src = url;

        document.head.appendChild(script);
    }

    window.swinger = window.swinger || {};

    try {
        const request = new XMLHttpRequest();
        request.addEventListener('load', () => {
            if (request.status !== 200) {
                return;
            }

            window.swinger.config = JSON.parse(request.responseText) || {};
            window.swinger.config.language = document.documentElement.getAttribute('lang') || window.swinger.config.language;

            preloadScript(`/resources/head.es5.js?v=${window.swinger.config.version}`);
            preloadScript(`/resources/main.es5.js?v=${window.swinger.config.version}`);
            preloadScript(`/resources/widgets/vendor.es5.js?v=${window.swinger.config.version}`);
            loadScript(`/resources/head.es5.js?v=${window.swinger.config.version}`, () => {
                loadScript(`/resources/main.es5.js?v=${window.swinger.config.version}`, () => {
                    loadScript(`/resources/widgets/vendor.es5.js?v=${window.swinger.config.version}`);
                });
            });
        });
        request.open('GET', '/swinger-data/config.json?nocache=' + (new Date()).getTime());
        request.send();
    } catch (e) {
        window.console.error('Fetching Swinger resources failed:', e);
    }

  const meJSON = window.localStorage.getItem('me');
  if (!meJSON) {
    return;
  }
  const me = JSON.parse(meJSON);
  if (
    me.preferences
    && me.preferences.displayMode
  ) {
    document.documentElement.classList.add(`scheme-${me.preferences.displayMode}`);
  }
})();
